<template>
  <v-app>
    <info></info>
    <set-status></set-status>
    <fast-create-booking></fast-create-booking>
    <transfer></transfer>
    <v-navigation-drawer
            v-if="isMobile"
            v-model="drawer"
            app
    >
      <div class="v-row">
        <div class="col-12">
          <div class="my-2" v-for="zone in zones" :key="zone.id">
            <v-btn  block :color="selectedZones.indexOf(zone.id) !== -1 ? 'indigo' : 'primary'" @click="setZone(zone.id)">{{zone.title}}</v-btn>
          </div>
        </div>
      </div>
    </v-navigation-drawer>
    <v-app-bar
            app
            color="primary"
            dark
    >
      <v-app-bar-nav-icon v-if="isMobile" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-btn icon @click="$router.push({name : 'restaurants'})">
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn @click="bringCloser" :disabled="lockBtn" icon>
        <v-icon >mdi-plus</v-icon>
      </v-btn>

      <v-btn  @click="moveAway" :disabled="lockBtn" icon>
        <v-icon >mdi-minus</v-icon>
      </v-btn>

      <v-btn @click="setSizeBYScreen" :disabled="lockBtn" icon>
        <v-icon >mdi-fullscreen</v-icon>
      </v-btn>
      <template v-if="!isMobile">
        <v-chip
                class="ma-2"
                color="blue"
                v-if="!isMobile"
        >
          Всего столов : {{this.data.allTables}}
        </v-chip>
        <v-chip
                class="ma-2"
                color="indigo"
                v-if="!isMobile"
        >
          Всего посадочный мест : {{this.data.allChairs}}
        </v-chip>
        <v-chip
                class="ma-2"
                color="orange"
                v-if="!isMobile"
        >
          Занято столов : {{this.data.fillTable}}
        </v-chip>
        <v-chip
                class="ma-2"
                color="green darken-4"
                v-if="!isMobile"
        >
          Занято посадочнх мест : {{this.data.fillChairs}}
        </v-chip>
      </template>
    </v-app-bar>

    <v-main style="position: absolute;
    overflow: auto;
    height: 100%;
    width: 100%;" >
      <app-map ref="map"
               :restaurant-id="restaurantId"
      ></app-map>
    </v-main>
    <v-footer
            absolute
            color="white"
            class="d-flex justify-center"
    >
      <v-btn v-if="getTablesOfCurrentReservation.length == 1" small color="error" @click="saveStatus(getTablesOfCurrentReservation[0], 5)">Освободить</v-btn>
      <v-btn v-if="getTablesOfNearestReservation.length == 1" small color="warning" @click="saveStatus(getTablesOfNearestReservation[0], 4)">Гость пришёл</v-btn>
      <v-btn v-if="getTablesAvailableForReservation.length" small color="error" @click="fastReservation">Занять</v-btn>
      <v-btn v-if="getTablesWhereHasReservations.length && !$store.getters['map/isTransfer'] && selectionTables.length <= 2" small color="blue" @click="transfer">Пересадить</v-btn>
      <v-btn v-if="selectionTables.length && $store.getters['map/isTransfer']" small color="dark-blue" @click="transfer">Отменить</v-btn>
      <v-btn v-if="selectionTables.length == 1" small color="indigo" @click="info">Инфо</v-btn>
      <v-btn v-if="selectionTables.length > 0" small color="warning" @click="clear">Очистить({{selectionTables.length}})</v-btn>
    </v-footer>
  </v-app>
</template>

<script>
  import AppMap from "./Map";
  import FastCreateBooking from "./FastCreateBooking";
  import SetStatus from "./SetStatus";
  import Transfer from "./Transfer";
  import Info from "./Info";

  const API_URL_SAVE_STATUS = 'reservation/:restaurantId/:reservationId/set-status';

  export default {
    components : {
      AppMap,
      FastCreateBooking,
      SetStatus,
      Transfer,
      Info
    },
    mounted() {
      axios.get('reservation/' + this.restaurantId + '/viewCurrentState')
              .then((data) => {
                this.data = data.data;
              }).then(() => {
        this.initApplication();


      })
      this.isMobile = window.isMobile;
    },
    props: {
      restaurantId: {
        type: [Number, String],
      },
    },
    data: () => ({
      selectedZones : [],
      modeTransfer : false,
      lockBtn : false,
      isMobile : false,
      drawer: false,
      data : {}
    }),
    computed:{
      getTablesWhereHasReservations(){
        return this.$store.getters['map/getTablesWhereHasReservations']
      },
      getTablesAvailableForReservation(){
        return this.$store.getters['map/getAvailableForReservation']
      },
      getTablesOfCurrentReservation(){
        return this.$store.getters['map/getTablesOfCurrentReservation']
      },
      getTablesOfNearestReservation(){
        return this.$store.getters['map/getTablesOfNearestReservation']
      },
      selectionTables(){
        return this.$store.getters['map/getSelectionTables']
      },
      zones() {
        return this.$store.getters['restaurantZones/getZones']
      },
      needDialogTransfer(){
        return this.$store.getters['map/isTransfer'] && this.$store.getters['map/getSelectionTables'].length == 2;
      }
    },
    watch:{
      needDialogTransfer(){
        if(this.needDialogTransfer){
          bus.$emit('transfer', {
            tables : this.selectionTables,
            restaurantId : this.restaurantId,
            allTables : this.$refs.map.tables
          })
        }
      }
    },
    methods:{
      clear(){
        bus.$emit('unselectedAllTables');
      },
      info(){
        let table = this.$refs.map.tables[this.selectionTables[0]];
        bus.$emit('infoAboutTable', table)
      },
      setZone(id){
        this.drawer = false;
        if(this.selectedZones.indexOf(id) !== -1){
          this.selectedZones.splice(this.selectedZones.indexOf(id), 1);
        }else{
          this.selectedZones.push(id);
        }

        if(this.selectedZones.length > 2){
          this.selectedZones.shift();
        }
        this.$refs.map.filterByZone(this.selectedZones)
      },
      fastReservation(){
        bus.$emit('createFastBooking', {
          tables : this.getTablesAvailableForReservation,
          restaurantId : this.restaurantId,
        })
      },
      transfer() {
        this.$store.commit('map/setModeTransfer', !this.$store.getters['map/isTransfer']);

        if(!this.$store.getters['map/isTransfer']){
          bus.$emit('unselectedAllTables')
        }
      },
      lock(){
        this.lockBtn = true;
      },
      unlock(){
        this.lockBtn = false;
      },
      call(cb){
        this.lock();
        cb();
        setTimeout(() => {
          this.unlock();
        }, 1000);
      },
      setSizeBYScreen(){
        this.call(this.$refs.map.setZoomFullScreen)
      },
      moveAway(){
        this.call(this.$refs.map.moveAway)
      },
      bringCloser(){
        this.call(this.$refs.map.bringCloser)
      },
      saveStatus(id, status) {
        let reservation = this.$refs.map.tables[id].today_reservation[0]
        let data = {
          status: status,
          comment: 'Измнил статус',
          sendSms: false
        };

        let url = API_URL_SAVE_STATUS
                .replace(':restaurantId', reservation.restaurant_id)
                .replace(':reservationId', reservation.id);

        axios.post(url, data);
      },
    }
  }
</script>
